@if (loading()) {
  <app-loading></app-loading>
} @else {
  @if (authenticated()) {
    <pre>{{ userInfo | json }}</pre>
    <p><a (click)="logout()">Logout</a></p>
  } @else {
    <p>You are not authenticated. <a href="/login">Login in</a></p>
  }
}
